var map = {
	"./de-DE.json": [
		1588,
		588
	],
	"./en-US.json": [
		7467,
		467
	],
	"./es-ES.json": [
		2230,
		230
	],
	"./fr-FR.json": [
		1426,
		426
	],
	"./ja-JP.json": [
		1043,
		43
	],
	"./ko-KR.json": [
		325,
		325
	],
	"./pt-BR.json": [
		998,
		998
	],
	"./zh-CN.json": [
		8557,
		557
	],
	"./zh-TW.json": [
		2769,
		769
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4358;
module.exports = webpackAsyncContext;